const GRADIENTS = [
  'from-orange-400/80 to-red-500/80',
  'from-blue-400/80 to-cyan-500/80',
  'from-green-400/80 to-emerald-500/80',
  'from-purple-400/80 to-pink-500/80',
  'from-slate-400/80 to-zinc-500/80',
  'from-pink-400/80 to-rose-500/80',
  'from-yellow-400/80 to-amber-500/80',
  'from-indigo-400/80 to-blue-500/80',
  'from-teal-400/80 to-cyan-500/80',
  'from-violet-400/80 to-purple-500/80',
  'from-rose-400/80 to-pink-500/80',
  'from-lime-400/80 to-green-500/80',
] as const;

export function deriveColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return GRADIENTS[hash % GRADIENTS.length];
}
